// Filter configuration and utility functions

// Category filter configuration
export const FILTER_OPTIONS = [
  { value: "all", label: "All Facilities" },
  { value: "sn", label: "Skilled Nursing" },
  { value: "bh", label: "Behavioral Health" },
  { value: "ph", label: "Psychiatric Health" },
  { value: "al", label: "Assisted Living" },
  { value: "mc", label: "Memory Care" },
  { value: "ot", label: "Outpatient Therapy" },
  { value: "ar", label: "Adult Residential" },
  { value: "sr", label: "Substance Recovery" },
  { value: "mhrc", label: "Mental Health Rehabilitation Centers" },
];

// Regional button configuration
export const REGION_BUTTONS = [
  { value: 7, label: "Northern", action: "setCAN" },
  { value: 8, label: "Central", action: "setCAC" },
  { value: 9, label: "Southern", action: "setCAS" },
];

// Helper function to get category display name
export const getCategoryWithoutLocale = (code) => {
  const categoryMap = {
    AL: "Assisted Living",
    BH: "Behavioral Health",
    PH: "Psychiatric Health",
    MC: "Memory Care",
    MHRC: "Mental Health Rehabilitation Centers",
    SN: "Skilled Nursing",
    OT: "Outpatient Therapy",
    AR: "Adult Residential",
    SR: "Substance Recovery",
  };
  return categoryMap[code] || null;
};

// Filter actions configuration - will be populated with actual functions from component
export const createFilterActions = (filterFunctions) => {
  return {
    all: { func: filterFunctions.setALL, title: "All" },
    sn: { func: filterFunctions.setSN, title: "Skilled Nursing" },
    bh: { func: filterFunctions.setBH, title: "Behavioral Health" },
    ph: { func: filterFunctions.setPH, title: "Psychiatric Health" },
    al: { func: filterFunctions.setAL, title: "Assisted Living" },
    mc: { func: filterFunctions.setMC, title: "Memory Care" },
    mhrc: { func: filterFunctions.setMHRC, title: "Mental Health Rehabilitation Centers" },
    ot: { func: filterFunctions.setOT, title: "Outpatient Therapy" },
    ar: { func: filterFunctions.setAR, title: "Adult Residential" },
    sr: { func: filterFunctions.setSR, title: "Substance Recovery" },
  };
};
